import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {getUser, is2faEnteredWhenLogin} from '@portal-workspace/grow-ui-library';
import {inject} from '@angular/core';
import {TwoFactorAuthService} from '../service/2fa.service';
import { Subject } from 'rxjs';
import {navigationUrlFor2FA} from '../service/navigation-urls';
import _ from 'lodash';

export const valid2faAccessGuard = (): CanActivateFn => {
  return async (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const subject = new Subject<boolean>;
    const router = inject(Router);
    const tfaService = inject(TwoFactorAuthService);
    const user = getUser();
    let is2faOn = user?.is2FA ?? false;
    
    const growRefreshToken = localStorage.getItem("adminGrowRefreshToken");
    const growAccessToken = localStorage.getItem("adminGrowAccessToken");
    const growUser = localStorage.getItem("adminGrowUser");
    if(!_.isEmpty(localStorage.getItem("isImpersonate")) && growUser && growAccessToken && growRefreshToken){
      is2faOn = false
    }
    
    if (user && is2faOn) {
          const is2faEntered = is2faEnteredWhenLogin();
          // if (!is2faTokenRegistered) { // no remember 2fa on device
            if (is2faEntered) { // correct 2fa code entered before
            } else { // no correct 2fa code entered before
              await router.navigate(navigationUrlFor2FA());
          }
    }
    return true;
  }
}
